import styled from 'styled-components';
import { device } from '../../../styles/breakpoints';
import { Header1 } from '../../atoms/Fonts';

export const RegisterPageContainer = styled.div`
  height: 100%;
  display: flex;
`;

export const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 400px;

  margin: 80px 20px 0 20px;

  @media ${device.laptop} {
    margin: 80px 16px;
  }

  @media ${device.tablet} {
    margin: 80px 16px;
  }

  @media ${device.mobile} {
    margin: 80px 0;
    padding: 0 20px;
  }
`;

export const Title = styled(Header1)`
  color: white;
  margin-bottom: 24px;
`;

export const RegisterStepOneContainer = styled.div`
  height: 100%;
  display: flex;
`;

export const TOSWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;

  @media ${device.desktopOnly} {
    max-width: 381px;
  }
`;

export const StepOneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media ${device.tablet} {
    align-items: initial;
    width: 100%;
  }
`;

export const ReturnWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;
